import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteTaxRate(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteTaxRate = (taxRateId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`tax-rates/${taxRateId}/`);
  };

  return useMutation(deleteTaxRate, {
    onSuccess: () => {
      queryClient.removeQueries('taxRates');
    },
  });
}
